<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <h1 class="title has-text-centered mgb-20px">
        {{ $t('listeDemandeImpression.popUpModificationCampagne.title') }}
      </h1>
      <error-msg-component :messages="messagesPopup"
                           :error="isErrorPopup"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="isErrorPopup = $event"/>
      <section class="mgt-10px">
        <div class="columns">
          <b-field class="column is-12 obligatoire"
              :label="$t('editionDemandeImpression.infoGenerale.campagne')">
              <b-autocomplete
                v-model="campagne"
                :placeholder="$t('editionDemandeImpression.infoGenerale.campagne')"
                :data="campagnes"
                field="libelle"
                :loading="isFetchingCampagne"
                :open-on-focus="true"
                icon="magnify"
                @input="getCampagnesDebounce"
                @select="option =>
                  campagneId = option ? option.id : null">
                <template #empty>
                  {{$t(`general.autocomplete.${!isFetchingCampagne
                    ? 'noRslt' : 'search'}`)}}
                </template>
                <template slot-scope="props">
                  <div class="columns is-vcentered">
                      <div class="column is-8 is-prewrap">
                        {{ props.option.libelle }}
                      </div>
                      <div class="column is-4 has-text-right"
                        v-if="props.option.urlLogoCampagne">
                        <div class="max-height-img-view-80">
                          <img :src="props.option.urlLogoCampagne"
                            class="max-width-100 max-height-80">
                        </div>
                      </div>
                  </div>
                </template>
              </b-autocomplete>
          </b-field>
        </div>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button class="button is-addOrEdit has-text-centered button-modal"
                  @click="updateMasseCampagne">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { updateCampagneDemandeImpressionAll } from '@/api/logistique/demandeImpression';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/demandeImpression/translateDemandeImpression';

const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    errorMsgComponent,
  },
  props: {
    demandeImpressions: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      campagne: null,
      campagnes: [],
      messagesPopup: [],
      messagesChampsVide: [],
      champsVide: [],
      isErrorPopup: false,
      getAllCampagnes,
      isFetchingCampagne: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getCampagnesDebounce: debounce(async function getCampagne(search) {
      if (search === '') {
        this.campagne = '';
        this.campagneId = null;
      }
      try {
        this.isFetchingCampagne = true;
        this.campagnes = (await getAllCampagnes({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            actif: true,
            avecLogo: true,
          },
        })).data.result.items;
        this.isFetchingCampagne = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingCampagne = false;
      }
    }, 300),
    async updateMasseCampagne() {
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messagesPopup = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesPopup = [];
        this.isErrorPopup = false;
        const demandeImpressionIds = this.demandeImpressions.map(demande => demande.id);
        await updateCampagneDemandeImpressionAll({
          ids: demandeImpressionIds,
          campagneId: this.campagneId,
        });
        messageSucces(this.$i18n.t(this.otIdsFromActionGroupe !== null ? 'listeExpedition.messages.success.otExpedie' : 'detailOrdreTravailTech.messages.changer.success'));
        this.$emit('update');
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesPopup, this.messagesChampsVide, translate);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
